import { useQuery } from "@apollo/client";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { MenuQuery } from "../../../graphql/deliveryService/queries/menu";
import { MenuItem } from "../../../models/autogenerated-deliveryService-gql/graphql";
import { handleError } from "../../../utils/graphqlHelper";

interface UseMenuQueryProps {
  skip?: boolean;
  dataAction: (data: MenuItem[]) => void;
  errorAction?: () => void;
}

const useMenuQuery = (props: UseMenuQueryProps) => {
  const { t } = useTranslation();
  const { skip = false, dataAction, errorAction } = props;

  const query = useQuery(MenuQuery, {
    skip,
    fetchPolicy: "network-only",
  });

  const { data, error } = query;
  const menuItems = data?.menu.items;

  useEffect(() => {
    if (!error) return;

    handleError(t("menuError"), error.message, errorAction);
  }, [error]);

  useEffect(() => {
    if (!data || !menuItems) return;

    dataAction(menuItems);
  }, [data]);

  return query;
};

export default useMenuQuery;
